import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { ApiService } from "../../api/api.service";
import { IBrandImage, IBrandImageDataRes, IBrandImageReq, ICreateBrandImageReq, IUpdateBrandImageReq } from "../../../_models/brand-image.model";
import { Observable } from "rxjs";
import { IAppResponse } from "../../../_interceptors/network-error.model";

@Injectable({
  providedIn: "root",
})
export class BrandImagesService {
  
  public endpoint: string = "admin";

  constructor(private apiService: ApiService) {}

  getAll(req: IBrandImageReq): Observable<IAppResponse<IBrandImageDataRes>> {
    let params = new HttpParams({
      fromObject: {
        page: String(req.page),
        limit: String(req.limit),
        ...(req.isActive != null && { isActive: String(req.isActive) }),
        ...(req.category && { category: req.category }),
        ...(req.search && { search: req.search }),
        ...(req.sort && { sortBy: req.sort }),
        ...(req.sortOrder && { sortOrder: req.sortOrder }),
        ...(req.includeDeleted != null && { includeDeleted: String(req.includeDeleted) }),
      },
    });

    return this.apiService.get<IBrandImageDataRes>({
      Url: `${this.endpoint}/brand-images`,
      Params: params,
    });
  }

  getPublicBrandImages(category: string): Observable<IAppResponse<IBrandImageDataRes>> {
    let params = new HttpParams({
      fromObject: { category }
    });

    return this.apiService.get<IBrandImageDataRes>({
      Url: `brand-images`,
      Params: params,
    });
  }

  createBrandImage(reqData: ICreateBrandImageReq): Observable<IAppResponse<IBrandImage>> {
    const form = new FormData();
    form.append("name", reqData.name);
    form.append("age", reqData.age.toString());
    form.append("message", reqData.message);
    form.append("category", reqData.category);
    form.append("imageType", reqData.imageType);
    form.append("isActive", reqData.isActive.toString());
    if (reqData.weight) {
      form.append("weight", reqData.weight);
    }
    if (reqData.order != null) {
      form.append("order", reqData.order.toString());
    }
    // The image can be a File or a Blob, we need to pass a filename if it's a blob.
    if (reqData.image instanceof File) {
      form.append("image", reqData.image, reqData.image.name);
    } else {
      form.append("image", reqData.image, "image.png");
    }

    return this.apiService.post<FormData, IBrandImage>({
      Url: `${this.endpoint}/brand-images`,
      Body: form,
    });
  }

  updateBrandImage(reqData: IUpdateBrandImageReq): Observable<IAppResponse<IBrandImage>> {
    const form = new FormData();
    if (reqData.name) form.append("name", reqData.name);
    if (reqData.age != null) form.append("age", reqData.age.toString());
    if (reqData.message) form.append("message", reqData.message);
    if (reqData.category) form.append("category", reqData.category);
    if (reqData.imageType) form.append("imageType", reqData.imageType);
    if (reqData.isActive != null) form.append("isActive", reqData.isActive.toString());
    if (reqData.weight) form.append("weight", reqData.weight);
    if (reqData.order != null) form.append("order", reqData.order.toString());
    
    if (reqData.image) {
      if (reqData.image instanceof File) {
        form.append("image", reqData.image, reqData.image.name);
      } else {
        form.append("image", reqData.image, "image.png");
      }
    }

    return this.apiService.put<FormData, IBrandImage>({
      Url: `${this.endpoint}/brand-images/${reqData.id}`,
      Body: form,
    });
  }

  bulkDeleteBrandImages(ids: string[]): Observable<IAppResponse<any>> {
    return this.apiService.post<{ids: string[]}, any>({
      Url: `${this.endpoint}/brand-images/bulk-delete`,
      Body: { ids }
    });
  }
}
